import styled, { css } from 'styled-components';

const StyledContainer = styled.label<{
	$height: number;
	$width?: number | string;
	$fontSize: number;
	$active: boolean;
	$disabled?: boolean;
}>`
	position: relative;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 4px;
	height: ${({ $height }) => $height}px;
	width: ${({ $width }) =>
		typeof $width === 'number' ? `${$width}px` : $width || 'auto'};
	padding: 0 14px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	color: rgba(255, 255, 255, 0.25);
	font-family: 'GT Walsheim Pro';
	font-size: ${({ $fontSize }) => $fontSize}px;
	line-height: 18px;
	font-weight: 700;
	cursor: text;
	user-select: none;
	transition:
		background-color 0.3s ease,
		color 0.3s ease,
		border-color 0.3s ease;

	${({ $active }) =>
		$active &&
		css`
			background-color: #2d70da;
			border-color: #2d70da;
			color: #ffffff;
		`}

	&:hover {
		background-color: #ffffff;
		border-color: rgba(255, 255, 255, 0.1);
		color: #000000;
	}

	&:focus-within {
		background-color: #ffffff;
		border-color: rgba(255, 255, 255, 0.1);
		color: #000000;
	}

	${({ $disabled }) =>
		$disabled &&
		css`
			pointer-events: none;
			opacity: 0.5;
		`}
`;

const StyledInput = styled.input.attrs({
	type: 'text',
	inputMode: 'numeric',
	autoComplete: 'off',
})<{ $fontSize: number }>`
	flex: 0 0 auto;
	width: auto;
	background: transparent;
	border: 0;
	outline: none;
	padding: 0;
	font-family: inherit;
	font-style: normal;
	font-weight: inherit;
	font-size: ${({ $fontSize }) => $fontSize}px;
	color: inherit;
	text-align: center;

	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		appearance: none;
		margin: 0;
	}
`;

const StyledUnit = styled.span<{ $active: boolean }>`
	flex-shrink: 0;
	font-weight: 400;
	opacity: ${({ $active }) => ($active ? 0.5 : 1)};
	pointer-events: none;
`;

export { StyledContainer, StyledInput, StyledUnit };
